// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:39:50

export default {
  "id": "wreck-the-tower",
  "slug": "wreck-the-tower",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/11d063f81e1b41c99bf6d1a40c83eb37-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/11d063f81e1b41c99bf6d1a40c83eb37/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Wreck The Tower",
      "description": "Take control of a powerful tank and unleash destruction in Wreck The Tower, an explosive demolition game where precision and power determine your success! Your mission is simple: demolish buildings by firing your tank’s bullets repeatedly until the structure collapses. But be careful not to hit the moving walls. If you hit them, your bullet will ricochet back toward you, adding an extra challenge to your aim.",
      "instructions": "Blast through buildings with your tank, aim carefully to avoid ricochets, and unlock new areas in this action-packed demolition game!",
      "genres": [
        "Shooter",
        "Casual"
      ],
      "tags": [
        "1player",
        "demolish",
        "skill",
        "tank",
        "3d"
      ]
    },
    "zh-CN": {
      "title": "破坏高塔",
      "description": "掌控一辆强大的坦克，在《摧毁高塔》这款爆炸性的拆除游戏中释放破坏力，精准与力量决定你的成功！你的任务很简单：通过不断发射坦克的炮弹来摧毁建筑物，直到结构崩塌。但要小心，不要击中移动的墙壁。如果你击中了它们，你的炮弹会反弹回来，给你的瞄准增添额外的挑战。",
      "instructions": "驾驶坦克炸穿建筑，小心瞄准避免弹跳，解锁全新区域，在这款动作满载的拆楼游戏中！",
      "genres": [
        "射击游戏",
        "休闲游戏"
      ],
      "tags": [
        "单玩家",
        "摧毁",
        "技能",
        "坦克",
        "3D"
      ]
    },
    "zh-TW": {
      "title": "摧毀高塔",
      "description": "掌控一台強力坦克，在《摧毀高塔》這款爆炸性的拆除遊戲中釋放毀滅力量，精準與力量將決定你的成功！你的任務很簡單：通過不斷射擊坦克的子彈來拆除建築物，直到結構倒塌為止。但要小心，不要擊中移動的牆壁。如果你擊中它們，你的子彈會反彈回來，為你的瞄準增添額外挑戰。",
      "instructions": "駕駛坦克摧毀建築，小心瞄準避免彈跳，並在這款充滿動作的拆除遊戲中解鎖新區域！",
      "genres": [
        "射擊",
        "休閒"
      ],
      "tags": [
        "1位玩家",
        "摧毀",
        "技能",
        "裝甲車",
        "3D"
      ]
    },
    "zh-HK": {
      "title": "摧毀高塔",
      "description": "掌握一輛強力坦克，在《摧毀高塔》這款爆炸性的拆除遊戲中釋放毀滅力量，精準與力量將決定你的成功！你的任務很簡單：通過不斷射擊坦克的子彈來拆除建築物，直到結構崩塌為止。但要小心，不要擊中移動的牆壁。如果你擊中它們，你的子彈會反彈回來，為你的瞄準增添額外挑戰。",
      "instructions": "駕駛坦克摧毀建築，小心瞄準避免跳彈，並在這款充滿動作的拆卸遊戲中解鎖新區域！",
      "genres": [
        "射擊",
        "休閒"
      ],
      "tags": [
        "1位玩家",
        "摧毀",
        "技能",
        "護甲車",
        "3D"
      ]
    },
    "ja": {
      "title": "「タワーを崩せ！」",
      "description": "強力な戦車を操り、『Wreck The Tower』で破壊の限界を引き出そう！この爆発的な解体ゲームでは、精度とパワーが成功の鍵だ。ミッションはシンプル：戦車の砲弾を繰り返し発射して建物を解体するのだ。しかし、動く壁には注意。それらに当てると、砲弾は跳ね返り、照準にさらなる挑戦が加わる。",
      "instructions": "建物を戦車で爆撃し、跳弾を避けるように慎重に照準を合わせ、このアクション満載の解体ゲームで新しいエリアをアンロックしよう！",
      "genres": [
        "シューティング",
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "破壊",
        "スキル",
        "タンク",
        "3D"
      ]
    },
    "ko": {
      "title": "타워 부수기",
      "description": "강력한 탱크를 조종하여 \"Wreck The Tower\"에서 파괴를 일으키세요! 정밀함과 파워가 성공을 좌우하는 폭발적인 철거 게임입니다! 당신의 임무는 간단합니다: 탱크의 총알을 반복적으로 발사하여 건물을 철거하세요. 하지만 움직이는 벽에 맞지 않도록 주의하세요. 만약 그들에 맞으면, 총알이 다시 당신 쪽으로 반사되어 목표에 대한 추가적인 도전이 생깁니다.",
      "instructions": "빌딩을 탱크로 박살내고, 반동을 피하기 위해 신중하게 조준하세요. 그리고 이 액션 가득한 철거 게임에서 새로운 영역을 해제하세요!",
      "genres": [
        "슈팅",
        "캐주얼"
      ],
      "tags": [
        "1인 플레이어",
        "파괴",
        "스킬",
        "탱크",
        "3D"
      ]
    },
    "fr": {
      "title": "Détruisez La Tour",
      "description": "Prenez le contrôle d'un puissant char et déchaînez la destruction dans Wreck The Tower, un jeu de démolition explosif où la précision et la puissance déterminent votre succès ! Votre mission est simple : démolissez les bâtiments en tirant les balles de votre char à plusieurs reprises jusqu'à ce que la structure s'effondre. Mais attention à ne pas toucher les murs mobiles. Si vous les heurtez, votre balle ricochera vers vous, ajoutant un défi supplémentaire à votre visée.",
      "instructions": "Détruisez des bâtiments avec votre tank, visez avec précision pour éviter les ricochets dans ce jeu d'action démolition. Débloquez de nouvelles zones au fur et à mesure de votre progression.",
      "genres": [
        "Tireur",
        "Casual"
      ],
      "tags": [
        "1 joueur",
        "démolition",
        "compétence",
        "char",
        "3D"
      ]
    }
  }
};
